const getAnrede = (anrede: string, titel: string | undefined, vorname: string, nachname: string) => {
    const persAnsprache = anrede === 'Herr' ? 'geehrter' : 'geehrte';

    return `Sehr ${persAnsprache} ${anrede} ${titel || ''} ${vorname} ${nachname},`;
};

export default getAnrede;
